export default __webpack_public_path__ + "static/hdmi_xr_adapter_m-c29fc7de7eb24327dc085d64558893d5.png";